export default class NextScrollBehaviorMock {
  updateScroll() {}

  registerElement() {}

  unregisterElement() {}

  stop() {}

}